import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { ResendUserInviteInput, ResendUserInviteMutation } from '@/gql/graphql';

const RESEND_USER_INVITE_MUTATION = graphql(`
  mutation ResendUserInvite($input: ResendUserInviteInput!) {
    resendUserInvite(input: $input) {
      id
      status
    }
  }
`);

const useResendUserInvite = (
  options?: UseMutationOptions<
    ResendUserInviteMutation,
    unknown,
    ResendUserInviteInput
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(RESEND_USER_INVITE_MUTATION, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountUsers(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useResendUserInvite;
